module.exports = __webpack_public_path__ + "static/img/traning01.62bca2e0.png";